import type { TenantCrawlOverviewDto } from "./types.ts";

export const InitializingCategoryKeys = [
    "isPeopleAndGroupsInitializing",
    "isSitesAndActivityInitializing",
    "isPermissionsInitializing",
    "isSharingAndExposureInitializing",
    "isTenantConfigurationsInitializing"
] as const;

export type InitializingCategoryKey = (typeof InitializingCategoryKeys)[number];

// Permissions and sharing/exposure aren't shown for migrate-assessment tenants, so they must be
// excluded from the initial-crawl-overview query's "is it done polling" check too — otherwise that
// query would keep polling on a category the UI already reports as complete.
export const MigrateExcludedCategories: InitializingCategoryKey[] = [
    "isPermissionsInitializing",
    "isSharingAndExposureInitializing"
];

export const InitializingCategoryTitles: Record<InitializingCategoryKey, string> = {
    isPeopleAndGroupsInitializing: "People and groups",
    isSitesAndActivityInitializing: "Sites and activity",
    isPermissionsInitializing: "Permissions",
    isSharingAndExposureInitializing: "Sharing and exposure",
    isTenantConfigurationsInitializing: "Tenant configurations"
};

export const MigrateCategoryKeys: readonly InitializingCategoryKey[] = InitializingCategoryKeys.filter(
    key => !MigrateExcludedCategories.includes(key)
);

export function isTenantScanning(
    tenant: TenantCrawlOverviewDto | undefined,
    categoryKeys: readonly InitializingCategoryKey[]
): boolean {
    if (!tenant) {
        return false;
    }

    return categoryKeys.some(key => tenant[key]);
}
